import exportPlugin from './exportPlugin.js';
import editorEventHandler from './editorEventHandler.js';
import SlimSelect from 'slim-select';
import StateManager from '../state_manager';
import infoPlugin from './infoPlugin';

const Handlebars = require('handlebars');
var _ = require('underscore');
var controlsMeta = '';
var isControlListEmpty = false;
var designerCodeForFirstControl = '';
var sourceFile = require('../../config/config.js');
const url = sourceFile.url;

var getAllControlIcons = async function() {
  return new Promise(function(resolve, reject) {
    var onSuccess = function(data) {
      data = data.replace('][', ',');
      data = JSON.parse(data);
      var iconsHTML = fnHandlebars('icons-suggestion-list-template', data);
      $('.existing-icon-list').append(iconsHTML);
      $('.existing-icon-list .loading-icons').remove();
      resolve(true);
    };
    var onAjaxError = function(error) {
      console.log(error);
      reject(false);
    };
    var reqObj = {
      operation: 'diy_getAllControlIcons'
    };
    fnAjaxRequest(
      url + 'Handler/ControlEditorHandler.ashx',
      'GET',
      reqObj,
      onSuccess,
      onAjaxError
    );
  });
};
var getControlsGroup = async function() {
  return new Promise(function(resolve, reject) {
    var ajaxReqData = {
      operation: 'getGroupsListForControls'
    };
    var onSuccess = function(data) {
      var groupData = JSON.parse(data);
      var groupList = groupData.map(function(obj) {
        return (
          '<option value=' +
          obj['group_id'] +
          '>' +
          obj['group_name'] +
          '</option>'
        );
      });
      groupList = `<option value="">Select…</option>` + groupList;
      $('.group .dropdown-select').html(groupList);
      resolve();
    };
    var onAjaxError = function(error) {
      error.status === 401 && ShowVSAlert('error', `You've been logged out`);
      console.log('unable to get group list');
      reject();
    };

    fnAjaxRequest(
      url + 'Handler/ControlEditorHandler.ashx',
      'GET',
      ajaxReqData,
      onSuccess,
      onAjaxError
    );
  });
};
var getMkpControlsGroup = async function() {
  return new Promise(function(resolve, reject) {
    var reqData = {
      operation: 'getControlmarketplaceGroups'
    };
    var onSuccess = function(data) {
      if (typeof data == 'string') {
        data = JSON.parse(data);
      }
      if (data.success) {
        var groupData =
          typeof data.data == 'string'
            ? JSON.parse(data.data)[0].data
            : data.data[0].data;
        var groupList = groupData.map(function(obj) {
          return '<option value=' + obj['id'] + '>' + obj['name'] + '</option>';
        });
        $('.edit-control-card .marketplace-group select').html(groupList);
        new SlimSelect({
          select: '.edit-control-card .marketplace-group select'
        });
        resolve();
      } else {
        console.log('unable to get group list');
        reject();
      }
    };
    var onAjaxError = function(error) {
      error.status === 401 && ShowVSAlert('error', `You've been logged out`);
      console.log('unable to get group list');
      reject();
    };
    fnAjaxRequest(
      url + 'Handler/controlMarketPlace.ashx',
      'POST',
      reqData,
      onSuccess,
      onAjaxError
    );
  });
};
var openAddControlModal = function() {
  $('.overlay-vs-input.for-add-function').fadeIn();
  let value = $('.overlay-vs-input.for-add-function')
    .find('.group .dropdown-select option')
    .filter(function(index, elm) {
      if (
        $(elm)
          .text()
          .trim()
          .toLowerCase() == 'custom'
      ) {
        return true;
      }
    })
    .attr('value');
  $('.overlay-vs-input.for-add-function')
    .find('.group .dropdown-select')
    .val(value || '');
};
var showLoader = function() {
  closeSidebar();
  $('.component-loader').removeClass('hide');
};
var hideLoader = function() {
  $('.studio-loader').hide();
  $('.component-loader').addClass('hide');
};
var storeDesignerCodeForFirstControl = function() {
  var html = editor.getHtml();
  var css = `<style>${editor.getCss()}</style>`;
  designerCodeForFirstControl = html + css;
};

var openEditControlModal = function() {
  // var current_control_json = current_control.value;
  var current_control_json = editor.Config.current_control;
  if (current_control_json) {
    current_control_json = JSON.parse(current_control_json);
    $('.edit-control-card .item-wrapper.name .text-value input').val(
      current_control_json.control_name
    );
    $('.edit-control-card .item-wrapper.disp-name .text-value input').val(
      current_control_json.display_name
    );
    $('.edit-control-card .item-wrapper.search-tag .text-value input').val(
      current_control_json.tags
    );
    $('.edit-control-card .item-wrapper.group .dropdown-select').val(
      current_control_json.group
    ); //TO-DO
    $('.edit-control-card .item-wrapper.status .mobileToggle')[0].checked =
      current_control_json.status;
    $('.edit-control-card .item-wrapper.depricated .isDeprecated')[0].checked =
      current_control_json.isDeprecated || 0;
    $('.edit-control-card .icon-picker .image-url').val(
      current_control_json.icon_url
    );
    $(
      ".edit-control-card .icon-picker [data-cmp-icon-url='" +
        current_control_json.icon_url +
        "']"
    )
      .parent()
      .addClass('is-selected');
    if (current_control_json.isOnMarketplace == 1) {
      $('.edit-control-card .marketplace input')
        .prop('checked', false)
        .trigger('click');
    } else {
      $('.edit-control-card .marketplace input')
        .prop('checked', true)
        .trigger('click');
    }

    if (current_control_json.hasOwnProperty('marketplace_data')) {
      $('.edit-control-card .marketplace-group select')[0].slim.set(
        current_control_json.marketplace_data.group
      );
      $('.edit-control-card .item-wrapper.image img').attr(
        'src',
        current_control_json.marketplace_data.image
      );
      current_control_json.marketplace_data.devices.forEach(function(device) {
        $(
          '.edit-control-card .item-wrapper.sd [data-device="' + device + '"]'
        ).addClass('selected');
      });
    }
    $('.overlay-vs-input.for-edit-function').fadeIn();
  }
};
var openPublishModal = function() {
  if (!isControlListEmpty) {
    $('.overlay-vs-input.for-publish').css('display', 'block');
    $('.vsCodeInput .release_notes').focus();
    $('.overlay-vs-input.for-publish')
      .off('keydown')
      .on('keydown', function(e) {
        if (e.keyCode == 13) {
          $('.vsCodeInput.publish .accept-button').trigger('click');
          $('.vsCodeInput .release_notes').blur();
        }
      })
      .keydown(function(e) {
        if (e.keyCode == 27) {
          $('.actions .close-button').trigger('click');
          $('.vsCodeInput .release_notes').blur();
        }
      });
  } else {
    storeDesignerCodeForFirstControl();
    editor.Panels.getButton('options', 'add-new-control').set('active', 1);
  }
};
var validateField = function($element, validationList = {}) {
  var defaultCheckList = {
    checkIsEmpty: false,
    checkSpecialChar: false,
    checkSpace: false,
    ignoreSpecialCharacter: ''
  };
  var checkList = $.extend(defaultCheckList, validationList);

  var startsWithCharRegex = /^[a-zA-Z]/;
  var format = /[`!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?]/;
  var formatWithoutComma = /[`!@#$%^&*()+\-=\[\]{};':"\\|.<>\/?]/;
  var text = $element.val().trim();
  var $errMsgBox = $element.parents('.item-wrapper').find('.error-msg-box');
  var hasSpecialCharacter,
    hasSpace,
    isEmpty = false;
  var starWithChar = true;
  if (checkList.checkIsEmpty) {
    isEmpty = text == '' ? true : false;
    if (isEmpty) showErrorInAddScriptModal($errMsgBox, 'Field cannot be empty');
  }
  if (checkList.checkSpace) {
    hasSpace = text.indexOf(' ') == -1 ? false : true;
    if (hasSpace)
      showErrorInAddScriptModal($errMsgBox, 'Field cannot contain spaces');
  }
  if (checkList.checkSpecialChar) {
    if (checkList.ignoreSpecialCharacter) {
      format = formatWithoutComma;
    }
    starWithChar = startsWithCharRegex.test(text);
    hasSpecialCharacter = format.test(text);
    if (hasSpecialCharacter) {
      showErrorInAddScriptModal(
        $errMsgBox,
        'Field cannot contain special characters'
      );
    }
    if (!starWithChar) {
      showErrorInAddScriptModal(
        $errMsgBox,
        'Field should start with character'
      );
    }
  }

  if (!hasSpecialCharacter && !hasSpace && !isEmpty && starWithChar) {
    $errMsgBox.text('');
    $element.removeClass('red-border');
    return true;
  } else {
    $element.addClass('red-border');
    return false;
  }
};
console.devLog = function(payload) {
  // console.log(payload)
};
var getCurrentTimeStamp = function() {
  var currentdate = new Date();
  var datetime =
    'DT:' +
    currentdate.getDate() +
    '/' +
    (currentdate.getMonth() + 1) +
    '/' +
    currentdate.getFullYear() +
    ' @ ' +
    currentdate.getHours() +
    ':' +
    currentdate.getMinutes() +
    ':' +
    currentdate.getSeconds();
  return datetime;
};
var merge_object_arrays = function(arr1, arr2, match) {
  return _.union(
    _.map(arr1, function(obj1) {
      var same = _.find(arr2, function(obj2) {
        return obj1[match] === obj2[match];
      });
      return same ? _.extend(obj1, same) : obj1;
    }),
    _.reject(arr2, function(obj2) {
      return _.find(arr1, function(obj1) {
        return obj2[match] === obj1[match];
      });
    })
  );
};
var ShowVSAlert = function(type, message, timeout = 3000) {
  var alertType = type || 'info';
  var alertMessage = message || '';
  $('.warning-icon').addClass('hide');
  $('.error-icon').addClass('hide');
  $('.success-icon').addClass('hide');
  if (alertType == 'info') {
    $('.warning-icon').removeClass('hide');
  } else if (alertType == 'error') {
    $('.error-icon').removeClass('hide');
  } else {
    $('.success-icon').removeClass('hide');
  }
  $('.alert-body .alert-text').html(alertMessage);
  $('.vsCodeAlert').fadeIn(function() {
    setTimeout(() => {
      $('.vsCodeAlert').fadeOut();
    }, timeout);
  });
};
var fnAjaxRequest = function(
  ajaxURL,
  ajaxReqMethod,
  ajaxReqData,
  onSuccess,
  onError
) {
  try {
    $.ajax({
      type: ajaxReqMethod,
      url: ajaxURL,
      data: ajaxReqData,
      success: onSuccess,
      error: onError,
      contentType: 'application/x-www-form-urlencoded'
    });
  } catch (ex) {
    // console.log('a')
  }
};
var startLoader = function(button) {
  var markup = button.get('markup');
  var classes = button.get('className');
  button.set('markup', `<div class="fa fa-spinner fa-pulse"></div>${markup}`);
  button.set('className', 'disabled');
};
var stopLoader = function(button, icon) {
  var markup =
    $(button.get('markup')).length == 2 ? $(button.get('markup'))[1] : '';
  button.set('markup', `${markup.outerHTML}`);
  button.set('className', icon);
};
var saveButtonClicked = async function() {
  var saveButton = editor.Panels.getButton('options', 'save-control');
  startLoader(saveButton);
  $('.vsCodeInput.publish .accept-button').addClass('disabled');
  // var current_control_json = current_control.value;
  var current_control_json = editor.Config.current_control;
  if (current_control_json && !isControlListEmpty) {
    current_control_json = JSON.parse(current_control_json);
    var c_name = current_control_json.control_name;
    var dis_name = current_control_json.display_name;
    // var isControlNamesValid = validateControlNamesOnScripts()
    // if (!isControlNamesValid) {
    //     return;
    // }
    var angularJSScript = '';
    var angularCSSScript = '';
    var angularTSScript = '';
    var cssScript = await exportPlugin.getCss();
    var coffeeScript = await exportPlugin.getCoffee(c_name, dis_name);
    var stateJson = StateManager.stateJson(editor);
    var reqObj = {
      action: 'update',
      operation: 'saveStudioControl',

      control_id: current_control_json.control_id,
      control_name: current_control_json.control_name,

      tags: current_control_json.tags,
      icon_url: current_control_json.icon_url,
      display_name: current_control_json.display_name,

      coffee: coffeeScript,
      handlebars: exportPlugin.getHB(c_name),
      css: cssScript,
      js: exportPlugin.getJs(c_name),
      states_data: JSON.stringify(stateJson),
      angular_js: current_control_json.angular_js,
      angular_css: current_control_json.angular_css,
      angular_ts: current_control_json.angular_ts,

      designer_html: editor.getHtml(),
      designer_css: editor.getCss()
    };
    var onSuccess = function(data) {
      $('.region-two-button-save .loader-wrapper').fadeOut();
      var index = data.indexOf(
        'Object reference not set to an instance of an object'
      );
      if (index > -1) {
        $('.error-loading.logout').removeClass('hide');
        ShowVSAlert('error', 'Error while saving! Please try again later.');
        stopLoader(saveButton, 'fa fa-save');
        $('.vsCodeInput.publish .accept-button').removeClass('disabled');
        return false;
      } else {
        ShowVSAlert('Success', 'Saved successfully!');
        stopLoader(saveButton, 'fa fa-save');
        $('.vsCodeInput.publish .accept-button').removeClass('disabled');
        editor.ControlManager.refreshList();
        // refreshControlList({ id: current_control_json.control_id }).then(
        //   function (response) {
        //     callListAfterRefresh(response.id);
        //     stopLoader(saveButton, 'fa fa-save');
        //     $('.vsCodeInput.publish .accept-button').removeClass('disabled');
        //   }
        // );
      }
    };
    var onAjaxError = function(data) {
      // console.devLog(data);
      stopLoader(saveButton, 'fa fa-save');
      $('.vsCodeInput.publish .accept-button').removeClass('disabled');
      if (data.status == 401) {
        ShowVSAlert('error', "It seems like you've been logged out.");
      } else {
        ShowVSAlert('error', 'Error saving control!');
      }
    };
    fnAjaxRequest(
      url + 'Handler/ControlEditorHandler.ashx',
      'POST',
      reqObj,
      onSuccess,
      onAjaxError
    );
  } else {
    storeDesignerCodeForFirstControl();
    editor.Panels.getButton('options', 'add-new-control').set('active', 1);
    stopLoader(saveButton, 'fa fa-save');
  }
};
var handleEscapeButton = function() {
  var isSidebarOpen = $('.list-sidebar').hasClass('is-open');
  isSidebarOpen ? closeSidebar() : false;
};
var shiftTabToLeft = function(e) {
  var currentTab = $('.display-header-option-script.is-selected').data('for');
  $('.display-header-option-script').removeClass('is-selected');
  switch (currentTab) {
    case 'css-container':
      $('.display-header-option-script[data-for=js-container]').addClass(
        'is-selected'
      );
      hideTabShowCurrent('js-container');
      break;
    case 'js-container':
      $('.display-header-option-script[data-for=hb-container]').addClass(
        'is-selected'
      );
      hideTabShowCurrent('hb-container');
      break;
    case 'hb-container':
      $('.display-header-option-script[data-for=coffee-container]').addClass(
        'is-selected'
      );
      hideTabShowCurrent('coffee-container');
      break;
    case 'coffee-container':
      $('.display-header-option-script[data-for=css-container]').addClass(
        'is-selected'
      );
      hideTabShowCurrent('css-container');
      break;
  }
};
var hideTabShowCurrent = function(datasetId) {
  $('.editor-body').addClass('editor-hidden');
  $('#' + datasetId).removeClass('editor-hidden');
};
//Richard ch7
var callListAfterRefresh = function(id) {
  var selectedControl = $('.script_item[data-control_id=' + id + ']');
  $('.accordion-body .script_item').removeClass('is-component-selected');
  selectedControl.addClass('is-component-selected');
  let name = selectedControl.find('.script_id').text();
  editor.Panels.getPanel('controlName').set(
    'prependContent',
    `<div class="name_containter">${name}</div>`
  );
  getComponent(id);
};
var clearAddNewComponentFields = function() {
  var $nameContainer = $(
    '.add-control-card .item-wrapper.name .text-value input'
  );
  var $summary = $('.add-control-card .item-wrapper .text-value textarea');
  var $definition = $('.add-control-card .item-wrapper .text-value input');
  var $example = $('.add-control-card .item-wrapper .text-value input');
  $nameContainer.val('');
  $summary.val('');
  $definition.val('');
  $example.val('');
  $('.add-control-card .item-wrapper.group .text-value select').val('');
  $('.add-control-card .red-border').removeClass('red-border');
  $('.add-control-card .error-msg-box').html('');
  $('.add-control-card .is-selected').removeClass('is-selected');
};
var clearUpdateComponentFields = function() {
  var $nameContainer = $(
    '.edit-control-card .item-wrapper.name .text-value input'
  );
  var $summary = $('.edit-control-card .item-wrapper .text-value textarea');
  var $definition = $('.edit-control-card .item-wrapper .text-value input');
  var $example = $('.edit-control-card .item-wrapper .text-value input');
  $nameContainer.val('');
  $summary.val('');
  $definition.val('');
  $example.val('');
  $('.edit-control-card .red-border').removeClass('red-border');
  $('.edit-control-card .error-msg-box').html('');
  $('.edit-control-card .is-selected').removeClass('is-selected');
  $('.edit-control-card .marketplace-group select')[0].slim.set([]);
  $('.edit-control-card .item-wrapper.image img').attr(
    'src',
    sourceFile.rootDir + '/assets/icons/imageblock.svg'
  );
  $('.edit-control-card .item-wrapper.sd .select-bar .item').removeClass(
    'selected'
  );
  $('.edit-control-card .item-wrapper.marketplace input')
    .prop('checked', true)
    .trigger('click');
};
var closeSidebar = function() {
  $('.list-sidebar').removeClass('is-open');
};
var openSidebar = function() {
  $('.list-sidebar').addClass('is-open');
};
var showErrorInAddScriptModal = function($element, ErrText) {
  $element.text(ErrText);
};
var fnHandlebars = function(tempId, data) {
  tempId = '#' + tempId;
  if (typeof data == 'string') {
    data = JSON.parse(data);
  }

  var tempHTML = $(tempId).html();

  var fnHandle = Handlebars.compile(tempHTML);
  return fnHandle(data);
};
var refreshControlList = function(dataToBePassedAfterPromise = {}) {
  return new Promise(function(resolve, reject) {
    var reqObj = {
      operation: 'GetStudioControlsListForEditor'
    };

    var onSuccess = function(data) {
      if (typeof data == 'string') {
        var index = data.indexOf(
          'Object reference not set to an instance of an object'
        );
        if (index > -1) {
          $('.error-loading').removeClass('hide');
          return false;
        }
      }
      console.devLog('getList success at ' + getCurrentTimeStamp());

      controlsMeta = JSON.parse(JSON.parse(data)['controls']);
      var status = JSON.parse(JSON.parse(data)['status']);
      controlsMeta = merge_object_arrays(controlsMeta, status, 'control_id');

      controlsMeta = controlsMeta.sort(function(a, b) {
        return a['control_id'] - b['control_id'];
      });
      controlsMeta = controlsMeta.filter(control => control['isFromDesigner']);
      var appsHtml = fnHandlebars('template-script-item', controlsMeta);
      $('.accordion-body.for-functions').html(appsHtml);
      console.devLog(controlsMeta);
      // $($($('.accordion-body')[0]).find('.script_item')[0]).trigger('click');
      resolve(dataToBePassedAfterPromise);
    };
    var onAjaxError = function(data) {
      if (data.status == 401) {
        $('.studio-loader')
          .find('.error-loading')
          .removeClass('hide');
      }
      console.devLog(data);
      reject();
    };
    console.devLog('refreshList called at ' + getCurrentTimeStamp());
    fnAjaxRequest(
      url + 'Handler/ControlEditorHandler.ashx',
      'POST',
      reqObj,
      onSuccess,
      onAjaxError
    );
  });
};
var clearModalContentForAll = function() {
  clearAddNewComponentFields();
  clearUpdateComponentFields();
};
var PublishCode = async function() {
  // var current_control_json = current_control.value;
  var current_control_json = editor.Config.current_control;
  var $releaseNotes = $('.vsCodeInput .release_notes');

  if (current_control_json) {
    current_control_json = JSON.parse(current_control_json);
    var c_name = current_control_json.control_name;
    var dis_name = current_control_json.display_name;
    var coffeeScript = await exportPlugin.getCoffee(c_name, dis_name);
    var cssScript = await exportPlugin.getCss();
    var release_notes = $releaseNotes.val();
    var stateJson = StateManager.stateJson(editor);
    var reqObj = {
      operation: 'publishStudioControl',

      control_id: current_control_json.control_id,
      control_name: current_control_json.control_name,

      tags: current_control_json.tags,
      icon_url: current_control_json.icon_url,
      display_name: current_control_json.display_name,
      group_id: current_control_json.group_id,
      release_notes: release_notes,
      states_data: JSON.stringify(stateJson),
      coffee: coffeeScript,
      handlebars: exportPlugin.getHB(c_name),
      css: cssScript,
      js: exportPlugin.getJs(c_name),

      angular_js: current_control_json.angular_js,
      angular_css: current_control_json.angular_css,
      angular_ts: current_control_json.angular_ts,

      designer_html: editor.getHtml(),
      designer_css: editor.getCss()
    };
    var onSuccess = function(data) {
      $releaseNotes.val('');
      $('.overlay-vs-input').css('display', 'none');
      var index = data.indexOf(
        'Object reference not set to an instance of an object'
      );
      if (index > -1) {
        $('.error-loading.logout').removeClass('hide');
        ShowVSAlert('error', 'Error while publishing! Please try again later.');
        return false;
      } else {
        ShowVSAlert('Success', 'Published successfully!');
      }
      $('.vsCodeInput .loader-wrapper').fadeOut();
      $('.vsCodeInput.publish .accept-button').removeClass('disabled');
    };
    var onAjaxError = function(data) {
      if (data.status == 401) {
        ShowVSAlert('error', "It seems like you've been logged out.");
      } else {
        ShowVSAlert('error', 'Error while publishing! Please try again later.');
      }
      // console.devLog(data);
      $('.vsCodeInput .loader-wrapper').fadeOut();
      $('.vsCodeInput.publish .accept-button').removeClass('disabled');
    };
    fnAjaxRequest(
      url + 'Handler/ControlEditorHandler.ashx',
      'POST',
      reqObj,
      onSuccess,
      onAjaxError
    );
  }
};
var addNewComponent = function(
  c_name,
  display_name,
  SearchTag,
  group,
  IconURL
) {
  $('.add-control-card .actions .accept-button .loader-wrapper').fadeIn();
  $('.add-control-card .actions .accept-button').addClass('disabled');
  var reqObj = {
    action: 'add',
    operation: 'addStudioControl',

    status: 0,
    group_id: group,
    control_name: c_name,

    tags: SearchTag,
    icon_url: IconURL,
    display_name: display_name,
    coffee: '',
    handlebars: '',
    css: '',
    js: '',
    angular_js: '',
    angular_css: '',
    angular_ts: '',
    designer_html: '',
    designer_css: '',
    is_designer: 1
  };
  var onSuccess = function(data) {
    let resp = JSON.parse(data);
    if (resp.success == false) {
      ShowVSAlert(
        'error',
        'A control with the same unique name already exists in the global/Local scope.'
      );
      // ShowVSAlert('error', 'You already have a control with same Unique name or a control with same unique name exists in Global scope');
      $('.add-control-card .actions .accept-button .loader-wrapper').fadeOut();
      $('.add-control-card .actions .accept-button').removeClass('disabled');
      return false;
    }
    $('.overlay-vs-input').css('display', 'none');
    ShowVSAlert('Success', 'Added successfully.');
    $('.add-control-card .actions .accept-button .loader-wrapper').fadeOut();
    $('.add-control-card .actions .accept-button').removeClass('disabled');
    clearAddNewComponentFields();
    // refreshControlList(resp).then(function (response) {
    //   callListAfterRefresh(response.id);
    // });
    editor.ControlManager.refreshList(resp.id);
  };
  var onAjaxError = function(data) {
    console.devLog(data);
    if (data.status == 401) {
      ShowVSAlert('error', "It seems like you've been logged out.");
    }
    $('.region-two-button-save .loading').css('display', 'none');
    $('.add-control-card .actions .accept-button .loader-wrapper').fadeOut();
    $('.add-control-card .actions .accept-button').removeClass('disabled');
  };
  fnAjaxRequest(
    url + 'Handler/ControlEditorHandler.ashx',
    'POST',
    reqObj,
    onSuccess,
    onAjaxError
  );
};
var updateControlMetaData = function(
  control_id,
  display_name,
  tags,
  group,
  status,
  icon_url,
  isDeprecated,
  onMarketplace,
  mkpgroup,
  mkpimageurl,
  supdevices
) {
  $('.edit-control-card .actions .accept-button .loader-wrapper').fadeIn();
  $('.edit-control-card .actions .accept-button').addClass('disabled');
  var reqObj = {
    operation: 'updateControlMeta',

    control_id: control_id,
    tags: tags,
    icon_url: icon_url,
    display_name: display_name,
    isDeprecated: isDeprecated,
    isOnMarketplace: onMarketplace ? 1 : 0,
    marketplace_data: JSON.stringify({
      image: mkpimageurl,
      group: mkpgroup,
      devices: supdevices
    }),
    dependencyJSON: JSON.stringify({ localDependencies: [] }),
    group: group,
    status: status
  };
  var onSuccess = function(data) {
    if (typeof data == 'string') {
      data = JSON.parse(data);
    }
    if (data.success) {
      // refreshControlList();
      editor.ControlManager.refreshList();
      $('.region-two-button-save .loading').css('display', 'none');
      ShowVSAlert('Success', 'Saved successfully!');
      $('.script_item.is-component-selected .script_id').text(
        this.display_name
      );
      if (this.status == 0) {
        $('.script_item.is-component-selected .status')
          .removeClass('is-active')
          .addClass('is-draft')
          .text('draft');
      } else {
        $('.script_item.is-component-selected .status')
          .removeClass('is-draft')
          .addClass('is-active')
          .text('active');
      }
      $('.edit-control-card .actions .accept-button .loader-wrapper').fadeOut();
      $('.edit-control-card .actions .accept-button').removeClass('disabled');
      $('.edit-control-card .header .close-button').trigger('click');
    } else {
      $('.region-two-button-save .loading').css('display', 'none');
      ShowVSAlert('error', data.message);
      $('.edit-control-card .actions .accept-button .loader-wrapper').fadeOut();
      $('.edit-control-card .actions .accept-button').removeClass('disabled');
    }
  };
  var onAjaxError = function(data) {
    // console.devLog(data);
    if (data.status == 401) {
      ShowVSAlert('error', "It seems like you've been logged out.");
    }
    $('.region-two-button-save .loading').css('display', 'none');
    $('.edit-control-card .actions .accept-button .loader-wrapper').fadeOut();
    $('.edit-control-card .actions .accept-button').removeClass('disabled');
    ShowVSAlert('error', 'Saved successfully!');
  };
  fnAjaxRequest(
    url + 'Handler/ControlEditorHandler.ashx',
    'POST',
    reqObj,
    onSuccess.bind(reqObj),
    onAjaxError
  );
};
var getComponent = function(id) {
  // console.devLog($($this[0]).data().control_id)
  console.devLog(id);
  var reqObj = {
    operation: 'getStudioControlByID',
    control_id: id
  };

  var onSuccess = function(data) {
    data = JSON.parse(data);
    var dev_document = data.filter(function(element) {
      return element['doc_type'] == 'dev';
    })[0];
    // var dev_document = data.find(function(element) {
    //   return element['doc_type'] == 'dev';
    // });
    var code = '';
    if (isControlListEmpty) {
      code = designerCodeForFirstControl;
    } else {
      var html = dev_document.designer_html || '';
      var css = `<style>
            ${dev_document.designer_css || ''}
        </style>`;
      code = html + css;
    }
    editor.CssComposer.clear();
    editor.DomComponents.getWrapper().set('content', '');
    editor.setComponents(code.trim());
    StateManager.init(editor, dev_document.states_data);
    var currentDocumentMeta = controlsMeta.filter(function(e) {
      return e.control_id == dev_document.control_id;
    })[0];
    // var currentDocumentMeta = controlsMeta.find(function(e) {
    //   return e.control_id == dev_document.control_id;
    // });
    dev_document['group'] = currentDocumentMeta.group;
    dev_document['status'] = currentDocumentMeta.status;
    dev_document['isDeprecated'] = currentDocumentMeta.isDeprecated || 0;
    dev_document['isOnMarketplace'] = currentDocumentMeta.isOnMarketplace || 0;
    // current_control.value = JSON.stringify(dev_document);
    editor.Config.current_control = JSON.stringify(dev_document);

    hideLoader();
    if (isControlListEmpty) {
      isControlListEmpty = false;
      saveButtonClicked();
    }
  };
  var onAjaxError = function(data) {
    hideLoader();
    if (data.status == 401) {
      ShowVSAlert('error', "It seems like you've been logged out.");
    }
    console.devLog('1');
    console.devLog(data);
  };
  fnAjaxRequest(
    url + 'Handler/ControlEditorHandler.ashx',
    'POST',
    reqObj,
    onSuccess,
    onAjaxError
  );
};
var HandleBarsHelpers = function() {
  Handlebars.registerHelper('ifCond', function(v1, v2, options) {
    if (v1 === v2) {
      return options.fn(this);
    }
    return options.inverse(this);
  });
};
HandleBarsHelpers();

/**
 * upload image to s3 and returns image url.
 */
var uploadImagetoS3 = function(fileData, success, error) {
  if (fileData) {
    var formData = new FormData();
    if (fileData instanceof Blob) {
      var extension = fileData.type.split('/')[1];
      formData.append(
        'blob',
        fileData,
        'api_' + new Date().getTime() + '.' + extension
      );
    } else {
      formData.append('file', fileData);
    }
    formData.append('dhqOperation', 'sessionImageUpload');

    $.ajax({
      type: 'POST',
      url: url + 'Handler/FormBuilderResponseHandler.ashx',
      data: formData,
      success: success.bind(this),
      error: error.bind(this),
      processData: false,
      contentType: false
    });
  }
};

/**
 * hides the group and modal from the edit and add control modal.
 */
var hideGroupAndIconFromModal = function() {
  let $group,
    $iconPicker,
    $marketplace,
    $mkpgrp,
    $mkpimgupload,
    $supdevice,
    $status,
    $depricated;
  $group = $('.edit-control-card .item-wrapper.group');
  $iconPicker = $('.edit-control-card .item-wrapper.icon-picker');
  $marketplace = $('.edit-control-card .item-wrapper .isOnMarketplace');
  $mkpgrp = $('.edit-control-card .item-wrapper.marketplace-group');
  $mkpimgupload = $('.edit-control-card .item-wrapper.image');
  $supdevice = $('.edit-control-card .item-wrapper.sd');
  $status = $('.edit-control-card .item-wrapper.status');
  $depricated = $('.edit-control-card .item-wrapper.depricated');
  if ($marketplace.length && $marketplace.prop('checked')) {
    $group.addClass('hide');
    $iconPicker.addClass('hide');
    $status.addClass('hide');
    $depricated.addClass('hide');
    $mkpgrp.removeClass('hide');
    $mkpimgupload.removeClass('hide');
    $supdevice.removeClass('hide');
  } else if ($marketplace.length) {
    $group.removeClass('hide');
    $iconPicker.removeClass('hide');
    $status.removeClass('hide');
    $depricated.removeClass('hide');
    $mkpgrp.addClass('hide');
    $mkpimgupload.addClass('hide');
    $supdevice.addClass('hide');
  }
};

var bindDragEvents = function($droparea, target) {
  let dropArea = $droparea[0];
  ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
    dropArea.addEventListener(eventName, preventDefaults, false);
  });
  dropArea.addEventListener('drop', handleDrop.bind(this), false);

  function handleDrop(e) {
    let dt = e.dataTransfer;
    let files = dt.files;
    if (target == 'add') {
      var $loader = $('.add-control-card .item-wrapper.image .image_loader');
      $loader.removeClass('hide');
      uploadImagetoS3(
        files[0],
        addControlMarketplaceImgSuccess.bind($loader),
        errorForControlMarketplaceImg.bind($loader)
      );
    } else {
      var $loader = $('.edit-control-card .item-wrapper.image .image_loader');
      $loader.removeClass('hide');
      uploadImagetoS3(
        files[0],
        editControlMarketplaceImgSuccess.bind($loader),
        errorForControlMarketplaceImg.bind($loader)
      );
    }
  }

  function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }
};

var addControlMarketplaceImgSuccess = function(data) {
  if (typeof data === 'string') {
    data = JSON.parse(data);
  }
  $('.add-control-card .item-wrapper.image .marketplace-icon img').attr(
    'src',
    data.image_url
  );
  this.addClass('hide');
};

var editControlMarketplaceImgSuccess = function(data) {
  if (typeof data === 'string') {
    data = JSON.parse(data);
  }
  $('.edit-control-card .item-wrapper.image .marketplace-icon img').attr(
    'src',
    data.image_url
  );
  this.addClass('hide');
};

async function validateCss() {
  let data = await exportPlugin.validateCss();
  if (!data.success) {
    ShowVSAlert('error', data.resp, 10000);
  }
  return data;
}

var errorForControlMarketplaceImg = function(error) {
  console.log(error);
  this.addClass('hide');
};
var bindClickEvent = function() {
  // market place toggle button for add and edit modal events
  $('body').on(
    'click',
    '.edit-control-card .item-wrapper.image .drop_zone span',
    function() {
      $('.edit-control-card .item-wrapper.image input').trigger('click');
    }
  );
  $('body').on(
    'change',
    '.edit-control-card .item-wrapper.image input',
    function(e) {
      var fileData = e.target.files && e.target.files[0];
      var $loader = $('.edit-control-card .item-wrapper.image .image_loader');
      $loader.removeClass('hide');
      uploadImagetoS3(
        fileData,
        editControlMarketplaceImgSuccess.bind($loader),
        errorForControlMarketplaceImg.bind($loader)
      );
    }
  );
  bindDragEvents(
    $('.edit-control-card .item-wrapper.image .image-upload-holder'),
    'edit'
  );
  $('body').on(
    'change',
    '.edit-control-card .isOnMarketplace:input',
    function() {
      hideGroupAndIconFromModal('edit');
    }
  );
  $('.edit-control-card .item-wrapper.sd .select-bar .item').on(
    'click',
    function(e) {
      $(e.currentTarget).toggleClass('selected');
    }
  );
  /// market place events end here
  $('body').on('click', '.accordion-body .script_item', function() {
    var $this = $(this);
    $('.accordion-body .script_item').removeClass('is-component-selected');
    $this.addClass('is-component-selected');
    var id = $this.data('control_id');
    let name = $this.find('.script_id').text();
    editor.Panels.getPanel('controlName').set(
      'prependContent',
      `<div class="name_containter">${name}</div>`
    );
    showLoader();
    getComponent(id);
  });
  $('.region-one-image').on('click', function() {
    window.location.href = '/apps.aspx';
  });
  $('.display-header-option-script').on('click', function() {
    var $this = $(this);
    $('.display-header-option-script').removeClass('is-selected');
    $this.addClass('is-selected');
    var clicked = $this.data('for');
    $('.editor-body').addClass('editor-hidden');
    $('#' + clicked).removeClass('editor-hidden');
  });
  $('.sidebar-close-button').on('click', function() {
    closeSidebar();
  });
  $('.list-header .header-main .header-primary .search input').on(
    'input',
    function() {
      var $this = $(this);
      var searchText = $this.val().toLowerCase();
      $('.accordion-body.for-functions .script_item').each(function(index, el) {
        var $el = $(el);
        var control_name = $el.find('.script_id').text();
        if (control_name.toLowerCase().includes(searchText)) {
          $el.show();
        } else {
          $el.hide();
        }
      });
    }
  );
  $('.header-accordion').on('click', function() {
    // var $this = $(this);
    // var accordionFor = $this.data('for');
    // $("." + accordionFor).slideToggle();
  });
  $('body').on('click', '.vsCodeAlert .close-button', function() {
    $('.vsCodeAlert').fadeOut();
  });
  $('.add-control-card .actions .close-button').on('click', function() {
    clearAddNewComponentFields();
  });
  $('.edit-control-card .actions .close-button').on('click', function() {
    clearUpdateComponentFields();
  });
  $('.region-two-button-publish').on('click', function() {
    // var errorsInCode = monaco.editor.getModelMarkers({});
    // if (errorsInCode.length == 0) {
    $('.overlay-vs-input.for-publish').css('display', 'block');
    $('.vsCodeInput .release_notes').focus();
    $('.overlay-vs-input.for-publish')
      .off('keydown')
      .on('keydown', function(e) {
        if (e.keyCode == 13) {
          $('.vsCodeInput.publish .accept-button').trigger('click');
          $('.vsCodeInput .release_notes').blur();
        }
      })
      .keydown(function(e) {
        if (e.keyCode == 27) {
          $('.actions .close-button').trigger('click');
          $('.vsCodeInput .release_notes').blur();
        }
      });
    // } else {
    //     ShowVSAlert('error', 'Document contains errors,Please correct before saving')
    // }
  });
  $('.vsCodeInput.publish .accept-button').on('click', function() {
    $(this).addClass('disabled');
    var Notes = $('.vsCodeInput .release_notes').val();
    if (!Notes) {
      $('.vsCodeInput .release_notes').addClass('red-border');
      return false;
    } else {
      $('.vsCodeInput .release_notes').removeClass('red-border');
    }
    $('.vsCodeInput .loader-wrapper').fadeIn();

    // var isControlNamesValid = validateControlNamesOnScripts()
    // if (!isControlNamesValid) {
    //     $('.vsCodeInput .loader-wrapper').fadeOut();
    //     return;
    // }
    saveButtonClicked();
    PublishCode();
  });
  $('.add-control-card .actions .accept-button').on('click', function() {
    var $nameContainer = $(
      '.add-control-card .item-wrapper.name .text-value input'
    );
    var $dispNameContainer = $(
      '.add-control-card .item-wrapper.disp-name .text-value input'
    );
    var $searchTagContainer = $(
      '.add-control-card .item-wrapper.search-tag .text-value input'
    );
    var $groupContainer = $(
      '.add-control-card .item-wrapper.group .text-value select'
    );
    var $IconContainer = $('.add-control-card .icon-picker .image-url');

    var f_name = $nameContainer.val().trim();
    var display_name = $dispNameContainer.val().trim();
    var SearchTag = $searchTagContainer.val();
    var group = $groupContainer.val();
    var IconURL = $IconContainer.val();

    var isValidFname = validateField($nameContainer, {
      checkIsEmpty: true,
      checkSpecialChar: true,
      checkSpace: true
    });
    var isValidDisplayName = validateField($dispNameContainer, {
      checkIsEmpty: true,
      checkSpecialChar: true,
      checkSpace: false
    });
    var isValidSearchTag = validateField($searchTagContainer, {
      checkIsEmpty: false,
      checkSpecialChar: true,
      checkSpace: false,
      ignoreSpecialCharacter: ','
    });

    var isFilledGroup = group == '' ? false : true;
    var isIconPicked = IconURL == '' ? false : true;

    if (!isFilledGroup) {
      $('.add-control-card .dropdown-dark').addClass('red-border');
      showErrorInAddScriptModal(
        $groupContainer.parents('.item-wrapper').find('.error-msg-box'),
        'Please select a group'
      );
    } else {
      $('.add-control-card .dropdown-dark').removeClass('red-border');
      showErrorInAddScriptModal(
        $groupContainer.parents('.item-wrapper').find('.error-msg-box'),
        ''
      );
    }
    if (!isIconPicked) {
      $('.add-control-card .existing-icon-list').addClass('red-border');
      showErrorInAddScriptModal(
        $IconContainer.parents('.item-wrapper').find('.error-msg-box'),
        'Please select a component Icon'
      );
    } else {
      $('.add-control-card .existing-icon-list').removeClass('red-border');
      showErrorInAddScriptModal(
        $IconContainer.parents('.item-wrapper').find('.error-msg-box'),
        ''
      );
    }

    if (
      isValidFname &&
      isValidDisplayName &&
      isValidSearchTag &&
      isFilledGroup &&
      isIconPicked
    ) {
      addNewComponent(f_name, display_name, SearchTag, group, IconURL);
    }
  });
  $('.edit-control-card .accept-button').on('click', function() {
    // var current_control_json = current_control.value;
    var current_control_json = editor.Config.current_control;
    if (current_control_json) {
      current_control_json = JSON.parse(current_control_json);
    }
    var control_id = current_control_json.control_id;
    var $dispNameContainer = $(
      '.edit-control-card .item-wrapper.disp-name .text-value input'
    );
    var $searchTagContainer = $(
      '.edit-control-card .item-wrapper.search-tag .text-value input'
    );
    var $groupContainer = $(
      '.edit-control-card .item-wrapper.group .text-value select'
    );
    var $IconContainer = $('.edit-control-card .icon-picker .image-url');

    var $MarketplaceToggle = $('.edit-control-card .marketplace input');

    var $MarketplaceGroup = $('.edit-control-card .marketplace-group select');

    var $MarketplaceImage = $('.edit-control-card .item-wrapper.image img');

    var $supdevices = $('.edit-control-card .item-wrapper.sd .select-bar');

    var status = $('.edit-control-card .item-wrapper.status .mobileToggle')[0]
      .checked
      ? 1
      : 0;
    var isDeprecated = $(
      '.edit-control-card .item-wrapper.depricated .isDeprecated'
    )[0].checked
      ? 1
      : 0;

    var IconURL = $IconContainer.val();
    var display_name = $dispNameContainer.val();
    var SearchTag = $searchTagContainer.val();
    var isOnMarketplace = $MarketplaceToggle.prop('checked');
    var imageurl = $MarketplaceImage.prop('src');
    var supdevices = [];
    $supdevices.find('.item.selected').each(function(i, e) {
      supdevices.push(e.dataset.device);
    });
    var isValidDisplayName = validateField($dispNameContainer, {
      checkIsEmpty: true,
      checkSpecialChar: true,
      checkSpace: false
    });
    var isValidSearchTag = validateField($searchTagContainer, {
      checkIsEmpty: true,
      checkSpecialChar: false,
      checkSpace: false
    });

    var group = $groupContainer.val();
    var marketplaceGroup = $MarketplaceGroup.val();

    if (isOnMarketplace) {
      var isFilledGroup = true;
      var isIconPicked = true;
      var isMarketGroupFilled = marketplaceGroup.length == 0 ? false : true;
      var isImageUploaded = imageurl.indexOf('amazonaws') > -1 ? true : false;
      var isdeviceselected = supdevices.length > 0 ? true : false;
      if (!isMarketGroupFilled) {
        $('.edit-control-card .marketplace-group .dropdown-dark').addClass(
          'red-border'
        );
        showErrorInAddScriptModal(
          $MarketplaceGroup.parents('.item-wrapper').find('.error-msg-box'),
          'Please select a group'
        );
      } else {
        $('.edit-control-card .marketplace-group .dropdown-dark').removeClass(
          'red-border'
        );
        showErrorInAddScriptModal(
          $MarketplaceGroup.parents('.item-wrapper').find('.error-msg-box'),
          ''
        );
      }
      if (!isdeviceselected) {
        $supdevices.addClass('red-border');
        showErrorInAddScriptModal(
          $supdevices.parents('.item-wrapper').find('.error-msg-box'),
          'Please select a supported device'
        );
      } else {
        $supdevices.removeClass('red-border');
        showErrorInAddScriptModal(
          $supdevices.parents('.item-wrapper').find('.error-msg-box'),
          ''
        );
      }
      if (!isImageUploaded) {
        $('.edit-control-card .image-upload-holder').addClass('red-border');
        showErrorInAddScriptModal(
          $MarketplaceImage.parents('.item-wrapper').find('.error-msg-box'),
          'Please upload an Icon'
        );
      } else {
        $('.edit-control-card .image-upload-holder').removeClass('red-border');
        showErrorInAddScriptModal(
          $MarketplaceImage.parents('.item-wrapper').find('.error-msg-box'),
          ''
        );
      }
    } else {
      var isFilledGroup = group == '' ? false : true;
      var isIconPicked = IconURL == '' ? false : true;
      var isMarketGroupFilled = true;
      var isImageUploaded = true;
      var isdeviceselected = true;
      if (!isFilledGroup) {
        $('.edit-control-card .dropdown-dark').addClass('red-border');
        showErrorInAddScriptModal(
          $groupContainer.parents('.item-wrapper').find('.error-msg-box'),
          'Please select a group'
        );
      } else {
        $('.edit-control-card .dropdown-dark').removeClass('red-border');
        showErrorInAddScriptModal(
          $groupContainer.parents('.item-wrapper').find('.error-msg-box'),
          ''
        );
      }

      if (!isIconPicked) {
        $('.edit-control-card .existing-icon-list').addClass('red-border');
        showErrorInAddScriptModal(
          $IconContainer.parents('.item-wrapper').find('.error-msg-box'),
          'Please select a component Icon'
        );
      } else {
        $('.edit-control-card .existing-icon-list').removeClass('red-border');
        showErrorInAddScriptModal(
          $IconContainer.parents('.item-wrapper').find('.error-msg-box'),
          ''
        );
      }
    }

    if (
      isValidDisplayName &&
      isValidSearchTag &&
      isFilledGroup &&
      isMarketGroupFilled &&
      isImageUploaded &&
      isdeviceselected &&
      isIconPicked
    ) {
      current_control_json.display_name = display_name;
      current_control_json.status = status;
      current_control_json.tags = SearchTag;
      current_control_json.group = Number(group);
      current_control_json.isDeprecated = isDeprecated;
      current_control_json.icon_url = IconURL;
      current_control_json.isOnMarketplace = isOnMarketplace;
      current_control_json.marketplace_data = {
        group: marketplaceGroup,
        image: imageurl,
        devices: supdevices
      };

      // current_control.value = JSON.stringify(current_control_json);
      editor.Config.current_control = JSON.stringify(current_control_json);
      updateControlMetaData(
        control_id,
        display_name,
        SearchTag,
        group,
        status,
        IconURL,
        isDeprecated,
        isOnMarketplace,
        marketplaceGroup,
        imageurl,
        supdevices
      );
    }
  });
  $('.for-edit-function .close-button').on('click', function() {
    clearModalContentForAll();
    clearUpdateComponentFields();
    $('.for-edit-function').fadeOut();
  });
  $(
    '.add-control-card .body .item-wrapper.icon-picker .existing-icon-list .icon-image'
  )
    .off('click')
    .on('click', function() {
      var $this = $(this);
      var imageURL = $this.find('.ui.image').data('cmpIconUrl');
      $(
        '.add-control-card .body .item-wrapper.icon-picker .existing-icon-list .icon-image'
      ).removeClass('is-selected');
      $this.addClass('is-selected');
      $('.add-control-card .icon-picker .image-url').val(imageURL);
    });
  $(
    '.edit-control-card .body .item-wrapper.icon-picker .existing-icon-list .icon-image'
  )
    .off('click')
    .on('click', function() {
      var $this = $(this);
      var imageURL = $this.find('.ui.image').data('cmpIconUrl');

      $(
        '.edit-control-card .body .item-wrapper.icon-picker .existing-icon-list .icon-image'
      ).removeClass('is-selected');
      $this.addClass('is-selected');
      $('.edit-control-card .icon-picker .image-url').val(imageURL);
    });
  $('.for-add-function .header-close-button')
    .off('click')
    .on('click', function() {
      $('.overlay-vs-input.for-add-function').fadeOut(function() {
        clearModalContentForAll();
        clearAddNewComponentFields();
      });
    });
  $('.actions .close-button')
    .off('click')
    .on('click', function() {
      $('.overlay-vs-input').fadeOut(function() {
        clearModalContentForAll();
        $('.release_notes').val('');
      });
    });
  $('.vsCodeInput .header .close-button')
    .off('click')
    .on('click', function() {
      $('.overlay-vs-input').css('display', 'none');
    });
  $(window).bind('keydown', function(event) {
    event.stopPropagation();
    if (event.key === 'Escape') {
      handleEscapeButton();
    }
    if (event.ctrlKey || event.metaKey) {
      switch (String.fromCharCode(event.which).toLowerCase()) {
        case 's':
          event.preventDefault();
          $('.region-two-button-save').trigger('click');
          break;
        case 'p':
          if (event.altKey) {
            event.preventDefault();
            $('.region-two-button-publish').trigger('click');
          }
          break;
        case 'b':
          $('.open-drawer').trigger('click');
          break;
        case '¼':
        case '¾':
          shiftTabToLeft(event);
          break;
      }
    }
    // if((e.ctrlKey && e.which == 9)){
    //     alert('lol')
    // }
  });

  // documentation
  $('body').on('mouseenter', '[data-hover_popup_doc_id]', infoPlugin.showPopUp);
  $('body').on('click', '[data-popup_doc_id]', infoPlugin.showPopUp);
};

var init = async function() {
  await getAllControlIcons();
  await getControlsGroup();
  await getMkpControlsGroup();
  infoPlugin.init();
  bindClickEvent();
  editorEventHandler.initEventHandler();
  editor.Panels.getButton('views', 'open-blocks').set('active', 1);
};

export default {
  addControl: openAddControlModal,
  editControl: openEditControlModal,
  saveControl: saveButtonClicked,
  openSidebar: openSidebar,
  export: openPublishModal,
  init: init,
  validateCss: validateCss,
  stateManager: StateManager,
  exportPlugin: exportPlugin,
  infoPlugin: infoPlugin
};
